import { render, staticRenderFns } from "./commandPage.vue?vue&type=template&id=4318f20c&scoped=true&"
import script from "./commandPage.vue?vue&type=script&lang=js&"
export * from "./commandPage.vue?vue&type=script&lang=js&"
import style0 from "./commandPage.vue?vue&type=style&index=0&id=4318f20c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4318f20c",
  null
  
)

export default component.exports